module.exports = __webpack_public_path__ + "static/img/partner1.186e4e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/partner1.png
// module id = jh3R
// module chunks = 1